import { ActionType, createReducer } from 'typesafe-actions';
import { LinkedPagesResponse } from '../types';
import { FETCH_LINKED_PAGES, RESET_LINKED_PAGES } from './actions';
import { combineReducers } from 'redux';

type ModelReducerActions =
  | ActionType<typeof FETCH_LINKED_PAGES.request>
  | ActionType<typeof FETCH_LINKED_PAGES.success>
  | ActionType<typeof FETCH_LINKED_PAGES.failure>
  | ActionType<typeof FETCH_LINKED_PAGES.cancel>
  | ActionType<typeof RESET_LINKED_PAGES>;

export const data = createReducer<LinkedPagesResponse | null, ModelReducerActions>(null)
  .handleAction([FETCH_LINKED_PAGES.failure, FETCH_LINKED_PAGES.cancel, RESET_LINKED_PAGES], () => null)
  .handleAction(FETCH_LINKED_PAGES.success, (_, { payload }) => payload);

export const loading = createReducer<boolean, ModelReducerActions>(false)
  .handleAction([FETCH_LINKED_PAGES.request], () => true)
  .handleAction(
    [FETCH_LINKED_PAGES.success, FETCH_LINKED_PAGES.failure, FETCH_LINKED_PAGES.cancel, RESET_LINKED_PAGES],
    () => false,
  );

export const error = createReducer<Error | string | null, ModelReducerActions>(null)
  .handleAction([FETCH_LINKED_PAGES.failure], (_, { payload }) => payload)
  .handleAction(
    [FETCH_LINKED_PAGES.request, FETCH_LINKED_PAGES.success, FETCH_LINKED_PAGES.cancel, RESET_LINKED_PAGES],
    () => null,
  );

export const linkedPagesReducer = combineReducers({
  data,
  loading,
  error,
});
